import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    '& .block': {
      width: '100%',
      minHeight: 100,
      [theme.breakpoints.down('md')]: {
        display: 'none'
      }
    }
  },
  root: {
    maxWidth: 600,
    width: '100%',
    height: '100%',
    '& .react-pdf__Document': {
      '& .react-pdf__Page': {
        '& .react-pdf__Page__svg': {
          width: '100% !important',
          height: '100% !important',
          maxHeight: `700px`,
          overflow: 'scroll !important',
          border: `8px solid ${colorSet.gray900}`,
          [theme.breakpoints.down('md')]: {
            border: 'none'
          }
        }
      }
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'cener',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: colorSet.gray900,
    padding: 8,
    position: 'relative',
    '& button': {
      padding: 4
    },
    '& svg': {
      color: colorSet.gray000,
      width: 20,
      height: 20
    },
    '& .pdf-page': {
      display: 'flex',
      alignItems: 'center',
      margin: '0px 4px',
      '& .divider': {
        display: 'block',
        margin: '0px 8px',
        color: colorSet.gray000,
        ...theme.typography.body2
      },
      '& .total': {
        display: 'block',
        color: colorSet.gray000,
        ...theme.typography.subtitle2,
        padding: 4
      }
    },
    '& .up-down': {
      display: 'flex',
      alignItems: 'center',

      '& .MuiOutlinedInput-root': {
        maxWidth: 24,
        width: '100%',
        '& fieldset': {
          display: 'none'
        }
      },
      '& input': {
        textAlign: 'center',
        padding: '4px !important',
        backgroundColor: colorSet.gray000,
        fontSize: `13px !important`
      }
    }
  }
}));

export default useStyles;
